import styles from './create.event.wrap.module.css'
import {useMemo } from 'react';
import { EventTime } from './EventTime';
import { AbsenceBlock } from './AbsenceBlock';
import { useEvents } from '../../contexts/calendar/EventsContext.context';
import { useAbsences } from '../../contexts/calendar/AbsencesContext.context';
import { Event } from '../../models/calendar/Event.model';
import { Absence } from '../../models/calendar/Absence.model';
import { useModalEvent } from '../../contexts/calendar/ModalEventContext.context';
import { useHistory } from 'react-router-dom';
import { useCalendar } from '../../contexts/calendar/CalendarContext.context';
import { useCompany } from '../../contexts/CompanyContext';
import { useConfig } from '../../contexts/ConfigContext';
import { AbsenceService } from '../../services/absence.api.client';
import { Modal, message } from 'antd';


type Props = {
    day:number,
    month:number,
    year:number,
    index:number,
    view:string
}


export const CreateEventWrap = ({ day, month, year,view }: Props) => {
    const {calendar} = useCalendar();
    const {events} = useEvents();
    const {absences, setAbsences} = useAbsences();
    const {setOptions} = useModalEvent();
    const history = useHistory();
    const {company} = useCompany();
    const {config} = useConfig();

    const currentDate =  new Date(year,month,day);
    const isAvaliable = useMemo(()=>{
        const updateDay = currentDate.getDay()<0?6:currentDate.getDay()-1
        return (calendar.availableWeekRules === undefined)?new Array(7).fill(true):calendar.availableWeekRules[updateDay];
    },[calendar.availableWeekRules]);

    const handleClickDay = () =>{
        //console.log('Se activo el hndle')
        setOptions((prev)=>({
            ...prev,
            isopen:true,
            numberOfWeek:currentDate.getDay(),
            day:day,
            month:month,
            year:year,
            id:'',
            isCreating:true,
            isEditing:false,
            isViewing:false
        }))
    }

    const isMonthView = useMemo(():boolean=>{
        return view === 'month';
    },[view]);

    const isDayView = useMemo(():boolean=>{
        return view === 'day';
    },[view]);

    const dayEvents = useMemo(()=>events.filter((event:Event)=>day==new Date(event.start).getDate()),[events,day]);

    const dayAbsences = useMemo(() => {
      if (day <= 0) return [];
      const cellStart = new Date(year, month, day).getTime();
      const cellEnd = cellStart + 24 * 60 * 60 * 1000;
      return absences.filter((a: Absence) => {
        const start = new Date(a.start_at).getTime();
        const end = new Date(a.end_at).getTime();
        return start < cellEnd && end > cellStart;
      });
    }, [absences, day, month, year]);

    const handleAbsenceClick = (absence: Absence) => {
      Modal.confirm({
        title: absence.contact?.name ? `${absence.contact.name} ausente` : "Ausencia",
        content: absence.note || "¿Eliminar esta ausencia?",
        okText: "Eliminar",
        okButtonProps: { danger: true },
        cancelText: "Cerrar",
        onOk: async () => {
          if (!config.key) throw new Error("Sin clave");
          await AbsenceService.deleteAbsence({ uid: absence.uid, company: company.current.uid }, config.key);
          setAbsences((prev) => prev.filter((a) => a.uid !== absence.uid));
          message.success("Ausencia eliminada");
        },
      });
    };

    const hiddenEventsTooltip = useMemo(()=>{
        if(dayEvents.length<=2) return '';
        return dayEvents.slice(2).map((e:Event)=>e.summary).join('\n');
    },[dayEvents]);

    return (
        <div className={styles["day-cell"]}>
            {dayAbsences.filter((a) => a.all_day).map((absence) => (
              <AbsenceBlock key={absence.uid} absence={absence} isDay={isDayView} onClick={handleAbsenceClick} />
            ))}
            {dayAbsences.filter((a) => !a.all_day).map((absence) => (
              <AbsenceBlock key={absence.uid} absence={absence} isDay={isDayView} onClick={handleAbsenceClick} />
            ))}
            {
                isMonthView
                ?
                dayEvents.slice(0,2).map(
                    (event:Event)=>
                        <EventTime event={event} key={event.id} isDay={isDayView}/>
                    )
                :
                dayEvents.map(
                    (event:Event)=>
                        <EventTime event={event} key={event.id} isDay={isDayView}/>
                    )
            }
            {
                (day>0&&isAvaliable)
                ?
                <div className={styles['rest-day-cell']} title="Crear nuevo evento" onClick={handleClickDay}></div>
                :
                <></>
            }
            {isMonthView&&dayEvents.length>2?
                <div className="more-time-range-event" 
                    title={hiddenEventsTooltip} 
                    onPointerDownCapture={()=>history.push(`/calendar/day/${year}/${month+1}/${day}`)}
                    style={{ "--time-range-color": calendar.color || "#3b82f6" } as React.CSSProperties}>
                    <span className='event-title'>More +{dayEvents.length-2}</span>
                </div>
            :<></>}

        </div>
    );
}